import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { handleReportUsageNotes } from 'src/common/redux/actions';

export function useReportUsageNotes({ usageDetails, dispatch }) {
    useEffectWithErrorLogging(() => {
        // Backward compat: older drafts stored adj notes under UsageAdjNote.
        const storedUsageNotes = Array.isArray(usageDetails?.usagecustomerNotes)
            ? usageDetails.usagecustomerNotes
            : [];
        const typedUsageAdjNotes = storedUsageNotes.filter(
            (note) => note?.typeOfNote === 'UsageAdjNote'
        );
        const usageAdjNotes =
            usageDetails?.usageAdjcustomerNotes || usageDetails?.UsageAdjNote;
        const reportUsageAdjNotes =
            usageAdjNotes?.length > 0 ? usageAdjNotes : typedUsageAdjNotes;
        if (
            usageDetails?.usageReplenishmentcustomerNotes ||
            usageDetails?.usagecustomerNotes ||
            reportUsageAdjNotes.length > 0
        ) {
            const prevSavedNotes = [
                {
                    reportUsageNotes:
                        storedUsageNotes.length > 0
                            ? storedUsageNotes.filter(
                                (note) => note?.typeOfNote !== 'UsageAdjNote'
                            )
                            : [],
                    reportReplenishmentNotes:
                        usageDetails?.usageReplenishmentcustomerNotes?.length > 0
                            ? usageDetails?.usageReplenishmentcustomerNotes
                            : [],
                    reportUsageAdjNotes:
                        reportUsageAdjNotes,
                },
            ];
            dispatch(handleReportUsageNotes(prevSavedNotes));
        }
    }, [usageDetails]);
}
